<template lang="html">
    <div>

      <!-- 1. Login / Continue as guest
        2. Discount code
        3. Choose payment type
        4. Choose ticket type (if existsts)
      -->

        <app-checkout-methods @update="updateMethod" @loading="updateLoading" @edit="edit(1)" @next="next" :completed="step > 1" />
        <app-checkout-tickets @update="updateTicket" @loading="updateLoading" @edit="edit(2)" @next="next" :completed="step > 2" v-if="step > 1" />
        <app-checkout-ticket-holders @update="updateFields" @loading="updateLoading" @edit="edit(3)" @next="next" :method="method" :completed="step > 3" v-if="step > 2" />
        <app-checkout-fields @update="updateFields" @loading="updateLoading" @edit="edit(4)" @next="next" :method="method" :ticket="ticket" :completed="step > 4" v-if="step > 3" />
        <!--<app-checkout-summary @loading="updateLoading" :method="method" :ticket="ticket" :completed="step > 4" v-if="step > 3" />-->
    </div>
</template>

<script>
import Summary from "./../Checkout/Partials/Summary";
export default {
  name: "basket-wrapper",
  components: {
    "app-checkout-partials-summary": Summary,
  },
  data: () => ({
    loading: true,
    summaryLoading: true,
    step: 1,
    method: "",
    ticket: "",
    fields: [],
  }),
  methods: {
    updateMethod(handle) {
      this.method = handle;
    },
    updateTicket(ticket) {
      this.ticket = ticket;
    },
    updateFields(fields) {
      this.fields = fields;
    },
    updateLoading(loading) {
      this.loading = loading;
    },
    updateSummaryLoading(loading) {
      this.summaryLoading = loading;
    },
    next() {
      this.step++;
    },
    edit(step) {
      this.step = step;
    },
  },
};
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// resources/js/components/Basket/Basket-wrapper.vue